import React, { useState, useEffect } from 'react';
import SEO from '../../components/SEO';
import FortuneContent from '../../components/fortune/FortuneContent';
import AdBanner from '../../components/AdBanner';
import { getLuckyToday } from '../../services/api';
import './FortuneCategoryPage.css';

function LuckyPage() {
  const [fortune, setFortune] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = '오늘의 행운 - 로또운세';
    fetchLuckyFortune();
  }, []);

  const fetchLuckyFortune = async () => {
    setLoading(true);

    try {
      const response = await getLuckyToday();
      if (response.success) {
        setFortune({
          title: '🍀 오늘의 행운',
          date: response.data.date,
          overall: response.data.message,
          luckyNumbers: response.data.luckyNumbers,
          luckyColor: response.data.luckyColor,
          luckyDirection: response.data.luckyDirection,
          luckyItem: response.data.luckyItem,
          luckyTime: response.data.luckyTime,
          luckyActivity: response.data.luckyActivity,
          luckyPlace: response.data.luckyPlace
        });
      }
    } catch (error) {
      console.error('Error fetching lucky fortune:', error);
      alert('행운 정보를 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fortune-category-page">
      <SEO
        title="AI 행운의 숫자 - 인공지능 오늘의 행운의 숫자 & 운세 숫자"
        description="AI 행운의 숫자를 확인하세요! 인공지능이 매일 분석하는 오늘의 행운의 숫자 6개, 행운의 색깔, 방향, 아이템을 무료로 제공합니다. AI 추천 로또 번호의 기초!"
        keywords="AI 행운의 숫자, 인공지능 행운의 숫자, 오늘의 행운의 숫자, 오늘의 운세 숫자, AI 추천 번호, AI 로또 번호 추천, 로또운세, 로또 운세, 행운의 색깔, 행운의 방향"
        url="https://lottounse.kr/fortune/lucky"
      />
      <div className="category-header lucky-header">
        <h1>🍀 AI 오늘의 행운의 숫자</h1>
        <p>인공지능 AI가 분석한 오늘의 행운의 숫자, 운세 숫자, 색깔, 방향, 아이템을 확인하세요</p>
      </div>

      <AdBanner />

      <div className="category-content lucky-content">
        {loading ? (
          <div className="loading-section">
            <p>오늘의 행운을 불러오는 중...</p>
          </div>
        ) : (
          <FortuneContent fortune={fortune} type="lucky" />
        )}
      </div>

      <AdBanner />
    </div>
  );
}

export default LuckyPage;
